<template>
  <span class="key-type">{{ keyType }}</span>
</template>
<script>
export default {
  name: 'KeyType',
  props: {
    scope: Object,
  },
  computed: {
    keyType() {
      var val = this.$getPropValue(this.scope.row, this.scope.column.property)
      return val
    },
  },
}
</script>
<style lang="less">
.key-type {
}
</style>